import { environmentVariables } from 'utils/environmentVariables';
import { apiGetRequest, generateApiRequestHeaders } from 'utils/http/apiHttp';

const apiUrl = environmentVariables.REACT_APP_API_HOST;

export const getMessages = async (breederId, listingId) => {
  const request = await apiGetRequest(
    `messaging/breeder/${breederId}`,
    `listingId=${listingId}`
  );
  return request.json?.messages;
};

export const createBreederMessage = async (payload) => {
  const headers = generateApiRequestHeaders();
  const request = await fetch(
    `${apiUrl}/api/messaging/breeder?application=${environmentVariables.REACT_APP_APPLICATION_ID}`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    }
  );

  if (!request.ok) {
    throw await request.json();
  }

  return request.json();
};

export const postInternalNote = async (payload) => {
  const headers = generateApiRequestHeaders();
  const request = await fetch(
    `${apiUrl}/api/listing/note?application=${environmentVariables.REACT_APP_APPLICATION_ID}`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    }
  );

  if (!request.ok) {
    throw await request.json();
  }

  return request.json();
};

export const getUsers = async (userIds) => {
  const promises = [];
  const headers = generateApiRequestHeaders();

  for (let userId of userIds) {
    promises.push(
      (
        await fetch(
          `${apiUrl}/api/access/user/${userId}?application=${environmentVariables.REACT_APP_APPLICATION_ID}`,
          {
            method: 'GET',
            headers,
          }
        )
      ).json()
    );
  }

  return Promise.all(promises);
};
